define("settings/templates/subscription/billing/tax-id", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{this.closeTaxIdForm}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.subscription.billing.tax.edit_tax_id"}} class="u--p__b__0" />
      <modal.card-body>
        <div class="u--m__t__md u--m__b">
          {{#if this.taxIdChangeset}}
            <Shared::TaxIdForm
              @onSubmit={{(noop)}}
              @shouldHideSubmitButton={{true}}
              @taxIdChangeset={{this.taxIdChangeset}}
            />
          {{/if}}
        </div>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @isDisabled={{this.isTaxIdPending}}
          @onClick={{this.closeTaxIdForm}}
          @text={{t "shared_words.cancel"}}
          @variant="outline"
          class="u--float--left"
        />
        <Shared::Ui::Button
          @isDisabled={{not this.canApplyTaxId}}
          @promise={{this.onTaxIdFormSubmit}}
          @variant="primary"
          class="u--float--right"
        >
          {{#if this.isSavingTaxId}}
            {{svg-jar "refresh" class="o--icon u--spin"}}
          {{/if}}
          {{t "checkout.tax.apply_vat"}}
        </Shared::Ui::Button>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "pA6xwajL",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,0,[\"closeTaxIdForm\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__0\"]],[[\"@title\"],[[28,[37,1],[\"account.subscription.billing.tax.edit_tax_id\"],null]]],null],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--m__t__md u--m__b\"],[12],[1,\"\\n\"],[41,[30,0,[\"taxIdChangeset\"]],[[[1,\"          \"],[8,[39,3],null,[[\"@onSubmit\",\"@shouldHideSubmitButton\",\"@taxIdChangeset\"],[[28,[37,4],null,null],true,[30,0,[\"taxIdChangeset\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--float--left\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"isTaxIdPending\"]],[30,0,[\"closeTaxIdForm\"]],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"],[8,[39,5],[[24,0,\"u--float--right\"]],[[\"@isDisabled\",\"@promise\",\"@variant\"],[[28,[37,6],[[30,0,[\"canApplyTaxId\"]]],null],[30,0,[\"onTaxIdFormSubmit\"]],\"primary\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isSavingTaxId\"]],[[[1,\"          \"],[1,[28,[35,7],[\"refresh\"],[[\"class\"],[\"o--icon u--spin\"]]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[1,[28,[35,1],[\"checkout.tax.apply_vat\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\"],false,[\"shared/modal\",\"t\",\"if\",\"shared/tax-id-form\",\"noop\",\"shared/ui/button\",\"not\",\"svg-jar\"]]",
    "moduleName": "settings/templates/subscription/billing/tax-id.hbs",
    "isStrictMode": false
  });
});